var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zlr-empty"},[_c('div',{staticClass:"zlr-empty-con"},[_c('img',{attrs:{"src":_vm.magnifier,"alt":""}}),_c('span',[_vm._v("Empty page, no result, try doing something")])])])}
var staticRenderFns = []

export { render, staticRenderFns }